import cookie from "cookie"
import fetch from "fetch"
import ua from "ua"
import url from "pnurl"
import { query } from "qs"
import evt from "event"
import store from "store2"
import { shared } from "progress"
import userService from "service/user"
import ChannelManager from "ChannelManager"
import bridge from "bridge"

var tiktokApi
var wxapi
var alipayAPI
var loadZHSDK
var loadBMAPI
if (process.browser) {
  wxapi = require("wxapi")
  alipayAPI = require("alipayAPI")
  tiktokApi = require("tiktokApi")
  if (ua.isFromZhaohang()) {
    loadZHSDK = require("zhaohangSdk").loadZHSDK
  }
  if (ua.isFromBanma) {
    loadBMAPI = require("banmaApi").loadBanmaSdk
  }
}

if (query.qunar == 1 && query.channel == "qunar") {
  store.session.set("qunar", true)
}

var cachedUser

let lightAssureLogin = function(redir) {
  var lightLogin = require("lightLogin")
  return lightLogin.assureLogin()
}

let assureLogin = function(redir, options = {}) {
  if (ua.isPiaoniu()) {
    return bridge.assureLogin()
  }
  if (!redir) {
    redir = decodeURIComponent(location.href)
  } else {
    redir = url.resolve(redir)
    redir = decodeURIComponent(redir)
  }
  window.pnlogger.sendPageLog("assureLogin " + redir)
  return new Promise((resolve, reject) => {
    isLogin().then(function(logged) {
      if (!logged) {
        window.pnlogger.sendPageLog("go login " + redir)
        login(redir, options)
          .then(resolve)
          .catch(reject)
      } else {
        window.pnlogger.sendPageLog("logined")
        if (options.assureWechat) {
          assureWechatLogin(redir).then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      }
    })
  })
}

let syncLogin = function(params) {
  const {token: pner, user: {userId: pnid}} = params;
  if (pnid) {
    cookie.set("pner", pner, 8760, ".piaoniu.com", "/")
    cookie.set("pnid", pnid, 8760, ".piaoniu.com", "/")
  }
}

let assureWechatLoginWithUserInfo = function(redir) {
  return assureWechatLogin(redir, true)
}

let syncCookie = function() {
  return new Promise((resolve, reject) => {
    const { pner, pnid, cityId } = query
    if (pner) {
      cookie.set("pner", pner, 8760, ".piaoniu.com", "/")
      cookie.set("pnid", pnid, 8760, ".piaoniu.com", "/")
      cookie.set("cityId", cityId, 24 * 365, ".piaoniu.com", "/")
      user
        .get()
        .then(function(user) {
          resolve(user)
        })
        .catch((err) => {
          reject(err)
        })
    } else {
      user.logout().then(() => {
        if (ua.isPiaoniuMiniProgram()) {
          wxapi.load().then(() => {
            wx.miniProgram.navigateTo({
              url: "/pages/bind-phone/index",
            })
          })
        }
        if (ua.isAliMiniProgram()) {
          alipayAPI.load().then(() => {
            my.navigateTo({
              url: `/pages/bind-phone/index`,
            })
          })
        }
        if (ua.isPiaoniuTiktokMiniProgram()) {
          tiktokApi.load().then(() => {
            tt.navigateTo({
              url: `/pages/bind-phone/index`,
            })
          })
        }
      })
    }
  })
}

let assureWechatLogin = function(redir, isUserinfoLogin) {
  return new Promise((resolve, reject) => {
    if (ua.isWechat() && !query.code) {
      wxapi.login({
        redir: redir,
        isUserinfoLogin: !!isUserinfoLogin,
      })
    } else {
      resolve()
    }
  })
}

let isDouli = function(req) {
  const user = require("user")
  if (req && req.cookies && !req.cookies.pner) {
    return Promise.resolve(false)
  }
  if (process.browser && !user.isLoginSync()) {
    return Promise.resolve(false)
  }
  return fetch({
    url: "/v1/user",
    failable: true,
  }).then((user) => {
    if (user) {
      return !!user.isDouliUser
    }
    return false
  })
}

let getId = function() {
  return cookie.get("pnid")
}

let isLoginSync = function() {
  return !!cookie.get("pnid")
}

let isLogin = function(url) {  
  const { pnid, pner } = query
  if (pnid) {
    cookie.set("pner", pner, 8760, ".piaoniu.com", "/")
    cookie.set("pnid", pnid, 8760, ".piaoniu.com", "/")
  }
  return new Promise((resolve, reject) => {
    var token = query.pnid || cookie.get("pnid")
    const pagePath = url ?  `/pages/bind-phone/index?redirect=${url}` : '/pages/bind-phone/index'
    if (ua.isPiaoniuMiniProgram()) {
      if (!token) {
        wxapi.load().then(() => {
          wx.miniProgram.navigateTo({
            url: pagePath,
          })
        })
      } else {
        resolve(!!token)
      }
    } else if (ua.isAliMiniProgram()) {
      if (!token) {
        alipayAPI
          .load()
          .then(() => {
            my.navigateTo({
              url: pagePath,
            })
          })
          .catch(() => {
            console.log("加载支付宝api失败!!!")
          })
      } else {
        resolve(!!token)
      }
    } else if (ua.isPiaoniuTiktokMiniProgram()) {
      if (!token) {
        tiktokApi
          .load()
          .then(() => {
            tt.miniProgram.navigateTo({
              url: pagePath,
            })
          })
          .catch(() => {
            console.log("加载抖音api失败!!!")
          })
      } else {
        resolve(!!token)
      }
    } else {
      resolve(!!token)
    }
  })
}

let isSelf = function(id) {
  return cookie.get("pnid") == id
}

var profiles = {}
let getProfile = function(id) {
  if (profiles[id]) {
    return profiles[id]
  } else {
    let req = fetch({
      url: `/v1/user/${id}`,
    })
    profiles[id] = req
    return req
  }
}

let getStat = function() {
  return fetch({
    url: "/v1/user/stat",
  })
}

let get = function() {
  return new Promise(function(resolve, reject) {
    if (!isLoginSync()) {
      return resolve(null)
    }
    if (cachedUser) {
      return resolve(cachedUser)
    }
    userService
      .get()
      .then((user) => {
        cachedUser = user
        resolve(user)
      })
      .catch((err) => {
        logout()
        reject(err)
      })
  })
}

const benefitIcons = () => {
  return fetch({
    url: "/v1/benefits/benefitIcons",
    method: "GET",
  })
}

let register = function(redir) {
  redir = redir || decodeURIComponent(location.href)
  location.href = "/user/register.html?redir=" + encodeURIComponent(redir)
}

// 在招行内且需要登陆的情况去登陆
let zhaohangLogin = (redir) => {
  return new Promise((resolve, reject) => {
    loadZHSDK().then(() => {
      window.pnlogger && window.pnlogger.sendEvent("action", "招行SDK加载成功")
      if (cookie.get("tper")) {
        fetch({
          url: "/v1/cmb/cmbAccessTokenCheck",
        }).then(({ data }) => {
          let valid = data.valid
          if (valid) {
            resolve()
          } else {
            zhaohangCodeLogin(resolve, reject, redir)
          }
        })
      } else {
        window.pnlogger.sendPageLog("go zhaohang code login " + redir)
        zhaohangCodeLogin(resolve, reject, redir)
      }
    })
  })
}

let banmaLogin = (redir, loginType) => {
  return new Promise((resolve, reject) => {
    loadBMAPI().then(() => {
      if (cookie.get("tper")) {
        resolve()
      } else {
        getBanmaAccountId().then((res) => {
          // 判断斑马是否登录
          if (+res.accountId) {
            fetch({
              url: `/v1/tpUnionLogin/${loginType}/getTpUserView`,
              method: "post",
              data: {
                accountId: res.accountId,
                os: res.osName,
                version: res.versionName,
              },
            })
              .then((data) => {
                resolve(data)
              })
              .catch((err) => {
                reject(err)
                shared.showMessage(err)
              })
          } else {
            window.ggj.login()
            // 每隔2s检查斑马是否登录
            setTimeout(() => {
              location.replace(redir)
            }, 2000)
          }
        })
      }
    })
  })
}

let getBanmaAccountId = () => {
  return new Promise((resolve, reject) => {
    loadBMAPI().then(() => {
      window.ggj.clientInfo.getCommonHeaders({
        complete(res) {
          resolve(res)
        },
      })
    })
  })
}

let zhaohangCodeLogin = (resolve, reject, redir) => {
  let cmbdata, code
  if (query.cmbdata) {
    cmbdata = JSON.parse(decodeURIComponent(query.cmbdata))
    code = cmbdata.code
  }
  if (code) {
    // 调招行登陆接口
    fetch({
      url: `/v1/cmb/tpLogin?code=${code}`,
      method: "post",
    }).then(
      () => {
        resolve()
      },
      (err) => {
        reject()
        shared.showProgress(err)
      }
    )
  } else {
    // 先去后台获取授权协议
    // getProtocol()
    fetch({
      url: "/v1/cmb/approval",
      data: {
        returnUrl: encodeURIComponent(redir || window.location.href),
      },
    }).then((protocol) => {
      if (ua.isProduct() || ua.isBeta()) {
        window.cmblife && window.cmblife.executeProtocol(protocol)
      } else {
        window.cmblife && window.cmblife.startSimulation(protocol)
      }
    })
  }
}

// 农行联合登录
let nonghangCodeLogin = () => {
  // 为了应对农行退出、换了账号、票牛没退出的场景
  // 希望农行在需要登录的链接配置 requireAuth 参数
  if (query.requireAuth) {
    let client_id = "PNW_TEST"
    if (ua.isProduct()) {
      client_id = "NH9dadd88c045db1f0"
    }
    let oauthLoginUrl = `https://www.abchina.com/luascript/oauthLogin/{"client_id":"${client_id}","redirect_uri":"https://m.piaoniu.com/api/v1/abchina/unionLogin","state":"m-piaoniu","scope":"openid","response_type":"code"}`
    if (query.isTravel) {
      oauthLoginUrl = `${oauthLoginUrl}&isTravel=true`
      console.log(oauthLoginUrl)
    }
    window.location.href = oauthLoginUrl
  }
}

let leHuoLogin = (redir) => {
  if (ua.isFromLehuo()) {
    return new Promise((resolve, reject) => {
      cookie.set("lehuo", "lehuo")
      fetch({
        method: "post",
        url: "/v1/tpLehuo/login",
        data: {
          token: query.token,
        },
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }
}

let assureTPLogin = (redir) => {
  const currentChannel = ChannelManager.current()
  if (currentChannel && currentChannel.login) {
    return currentChannel.login(redir)
  } else {
    return Promise.resolve()
  }
}

let assurePiaoniuLogin = (redir) => {
  if (isLoginSync()) {
    return Promise.resolve()
  } else {
    return _piaoniuLogin(redir)
  }
}

let _piaoniuLogin = (redir) => {
  let redirStr = encodeURIComponent(redir || location.href)
  return new Promise((resolve) => {
    if (ua.isMobile()) {
      location.href = "/user/login.html?redir=" + redirStr
      resolve()
    } else {
      let lightLogin = require("./lightLogin")
      lightLogin.show()
      lightLogin.on("login", () => {
        user.emit("login")
        resolve()
      })
    }
  })
}

let login = function(redir, options) {
  redir = redir || decodeURIComponent(location.href)
  const currentChannel = ChannelManager.current()
  const forcePiaoniu = options && options.forcePiaoniu
  window.pnlogger.sendPageLog("forcePiaoniu" + forcePiaoniu)
  if (currentChannel && currentChannel.login && !forcePiaoniu) {
    return currentChannel.login(redir)
  } else {
    return _piaoniuLogin(redir)
  }
}

let getToken = function() {
  return new Promise((resolve, reject) => {
    resolve(cookie.get("pner"))
  })
}

let logout = function() {
  const sensors = require("sensors")
  sensors.logout()
  cookie.set("pnid", null, -1, ".piaoniu.com")
  cookie.set("tper", null, -1, ".piaoniu.com")
  cookie.set("pufaAppLogin", null, -1, ".piaoniu.com")
  return fetch({
    dataType: "text",
    url: "/v1/user/logout",
  })
}

var user = {
  syncCookie,
  get,
  getProfile,
  getStat,
  getId,
  getToken,
  login,
  logout,
  register,
  assureTPLogin,
  assurePiaoniuLogin,
  assureLogin,
  syncLogin,
  isSelf,
  lightAssureLogin,
  isLogin,
  isLoginSync,
  isDouli,
  assureWechatLoginWithUserInfo,
  assureWechatLogin,
  leHuoLogin,
  zhaohangLogin,
  nonghangCodeLogin,
  banmaLogin,
  getBanmaAccountId,
  benefitIcons,
}

evt.mixin(user)

module.exports = user



// WEBPACK FOOTER //
// ./src/mods/user.js